export const FETCH_HEADER_OPTIONS = {
	Accept: '*/*',
	'AcceptAccess-Control-Request-Headers': 'content-type',
	'Content-Type': 'application/json',
	'Access-Control-Allow-Credentials': true,
}
